// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__2jxft","cell":"ColumnAccessor_cell__1KNz4","firstCellAccent":"ColumnAccessor_firstCellAccent__2H6CJ"};